import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  List,
  Paper,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import { ScopeDialog } from "./ScopeDialog";
import { ScopeListItem } from "./ScopeListItem";
import { Skeleton } from "@material-ui/lab";
import { Scope } from "../../domain/Scope";
import { LookupTrackerStore } from "@ofqual/portal-core/core/types";
import { ScopesFilterMenu } from "./ScopesFilterMenu";
import { SearchCoreMethods } from "@ofqual/portal-core/core/hooks";
import { FixedSizeList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import { FullHeightWidthArea } from "@ofqual/portal-components/components/FullHeightWidthArea";
export type ScopesProps = {
  canEdit?: boolean;
  scopes: Scope[];
  canApprove?: boolean;
  actions?: {
    onToggleDeleteScopes: (scopes: Scope[]) => void;
    onDeleteScopes: () => void;
    onAddScope: (scope: Scope) => void;
    onUpdateScope: (
      scope: Scope,
      loolupTrackingInfo: LookupTrackerStore
    ) => void;
  };
  existingScopes?: Scope[];
  search?: SearchCoreMethods;
  isScrollableList?: boolean;
  allowSetScopeStart?: boolean;
};

export const ScopesList: React.FC<ScopesProps> = ({
  canEdit,
  scopes,
  canApprove,
  actions,
  existingScopes,
  search,
  isScrollableList,
  allowSetScopeStart
}) => {
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [prevAddedScope, setPrevAddedScope] = useState<Scope | null>(null);

  const scopesToDelete = scopes.filter((x) => x.shouldDelete);
  const areAllCheckboxesChecked = scopes.length
    ? scopes.every((scope) => scope.shouldDelete)
    : false;

  const toggleDeleteScopeItem = (scope: Scope) =>
    actions?.onToggleDeleteScopes([scope]);

  const toggleSelectAll = () => actions?.onToggleDeleteScopes(scopes);

  const renderListItem = (index: number) => (
    <ScopeListItem
      item={scopes[index]}
      scopes={scopes}
      canEdit={canEdit}
      toggleDeleteScope={toggleDeleteScopeItem}
      canApprove={canApprove}
      onUpdate={actions?.onUpdateScope}
      existingScopes={existingScopes}
    />
  );

  const onAdd = (scope: Scope) => {
    setPrevAddedScope(scope);
    actions?.onAddScope && actions?.onAddScope(scope);
  }

  return (
    <>
      <Grid container>
        {canEdit ? (
          <>
            <Grid item>
              <FormControlLabel
                value="selectAll"
                control={<Checkbox checked={areAllCheckboxesChecked} />}
                label={
                  <Typography variant="subtitle2">
                    Select/Deselect All
                  </Typography>
                }
                labelPlacement="end"
                onChange={toggleSelectAll}
              />
            </Grid>
            <Grid item>
              <Button
                color="primary"
                onClick={() => setOpenDialog(true)}
                data-test="add-qualification"
              >
                Add Scope
              </Button>
            </Grid>
            <Grid item>
              <Button
                color="primary"
                onClick={actions?.onDeleteScopes}
                data-test="add-qualification"
                disabled={!scopesToDelete.length}
              >
                Remove {scopesToDelete.length} Scopes
              </Button>
            </Grid>
          </>
        ) : null}
        <Grid container justify="flex-end">
          {search && <ScopesFilterMenu search={search} />}
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12}>
          {scopes ? (
            <Paper>
              {isScrollableList ? (
                <FullHeightWidthArea topOffset={185}>
                  <AutoSizer>
                    {({ height, width } : {height: string | number, width: string | number})  => (
                      <FixedSizeList
                        height={height}
                        itemCount={scopes.length}
                        itemSize={100}
                        width={width}
                      >
                        {({ index, style }) => (
                          <div style={style}>{renderListItem(index)}</div>
                        )}
                      </FixedSizeList>
                    )}
                  </AutoSizer>
                </FullHeightWidthArea>
              ) : (
                <List disablePadding>
                  {scopes.map((item, index) => (
                    <React.Fragment key={scopes[index].id}>
                      {renderListItem(index)}
                    </React.Fragment>
                  ))}
                </List>
              )}
            </Paper>
          ) : (
            <>
              <Skeleton variant="text" height={60} />
              <Skeleton variant="text" height={60} />
              <Skeleton variant="text" height={60} />
              <br />
              <Skeleton variant="rect" height={118} />
            </>
          )}
        </Grid>
      </Grid>
      {openDialog ? (
        <ScopeDialog
          onClose={() => setOpenDialog(false)}
          scopes={scopes}
          onAdd={actions?.onAddScope && ((s) => onAdd(s))}
          existingScopes={existingScopes}
          prevAddedScope={prevAddedScope}
          allowSetScopeStart={allowSetScopeStart}
        />
      ) : null}
    </>
  );
};
